import React from "react";
import BasicLayout from "./BasicLayout";
import Divider from "components/Divider";
import TextField from "components/fields/TextField";
import InputField from "components/fields/InputField";

const sections = [
    {
        fields: [
            {
                label: "Ragione sociale*",
                name: "name",
                type: "text",
                placeholder: "Ragione sociale",
                required: true,
                tooltip: "Denominazione legale completa del cliente finale",
                colSpan: "col-span-2",
            },
        ],
    },
    {
        fields: [
            {
                label: "Email*",
                name: "email",
                type: "email",
                placeholder: "email@esempio.com",
                required: true,
                tooltip: "Indirizzo e-mail del cliente finale",
                colSpan: "col-span-2",
            },
            {
                label: "Telefono*",
                name: "phone1",
                type: "text",
                placeholder: "Telefono",
                required: true,
                tooltip: "Numero di telefono del cliente finale",
                colSpan: "col-span-2",
            },
            {
                label: "Telefono 2",
                name: "phone2",
                type: "text",
                placeholder: "Telefono 2",
                tooltip: "Numero di telefono alternativo del cliente finale",
                colSpan: "col-span-2",
            },
            {
                label: "Cellulare",
                name: "mobile",
                type: "text",
                placeholder: "Cellulare",
                tooltip: "Numero di telefono cellulare del cliente finale",
                colSpan: "col-span-2",
            },
        ],
    },
    {
        fields: [
            {
                label: "Referente commerciale*",
                name: "commercial_reference",
                type: "text",
                placeholder: "Referente commerciale",
                required: true,
                tooltip:
                    "Nome e cognome del referente commerciale del cliente finale",
                colSpan: "col-span-2",
            },
            {
                label: "Referente tecnico*",
                name: "technical_reference",
                type: "text",
                placeholder: "Referente tecnico",
                required: true,
                tooltip:
                    "Nome e cognome del referente tecnico del cliente finale",
                colSpan: "col-span-2",
            },
        ],
    },
    {
        fields: [
            {
                label: "Indirizzo*",
                name: "address",
                type: "text",
                placeholder: "Indirizzo",
                required: true,
                tooltip:
                    "Indirizzo della sede di installazione dell’azienda cliente",
                colSpan: "col-span-2",
            },
            {
                label: "Città*",
                name: "city",
                type: "text",
                placeholder: "Città",
                required: true,
                tooltip: "Comune della sede di installazione",
            },
            {
                label: "Provincia*",
                name: "province",
                type: "text",
                placeholder: "PR",
                required: true,
                tooltip:
                    "Sigla provincia della sede di installazione (2 caratteri maiuscoli)",
            },
            {
                label: "CAP*",
                name: "zip_code",
                type: "text",
                placeholder: "CAP",
                required: true,
                tooltip:
                    "Codice di avviamento postale della sede di installazione",
            },
            {
                label: "Nazione*",
                name: "country",
                type: "text",
                placeholder: "Nazione",
                required: true,
                tooltip: "Nazione della sede di installazione",
            },
        ],
    },
];

const Step1 = ({ activationType, state, setState, message }) => {
    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;

        const mappedValue = name === "province" ? value.toUpperCase() : value;

        setState((state) => ({
            ...state,
            data: {
                ...state.data,
                [name]: mappedValue,
            },
        }));
    };

    const getFieldState = (field) =>
        message.hasOwnProperty("errors") &&
        message.errors.hasOwnProperty(`data.${field}`)
            ? "error"
            : null;

    const getFieldError = (field) =>
        message.hasOwnProperty("errors") &&
        message.errors.hasOwnProperty(`data.${field}`)
            ? message.errors[`data.${field}`]
            : null;

    return (
        <BasicLayout
            title="Inserisci i dati anagrafici del cliente finale"
            subtitle={
                <>
                    Questo è il primo passo per attivare la tua piattaforma
                    Proxima <span className="capitalize">{activationType}</span>
                    . <br />
                    Compila il form con i dati anagrafici aziendali del cliente
                    finale.
                </>
            }
            content={
                <div className="flex flex-col gap-8">
                    <div className="info-box">
                        <strong>
                            Perché ti chiediamo di inserire i dati del cliente
                            finale?
                        </strong>
                        <br />
                        Per completare correttamente l'attivazione dei servizi,
                        ti chiediamo di inserire i dati anagrafici del cliente
                        finale. Queste informazioni sono necessarie per:
                        <ul
                            style={{
                                listStyle: "disc",
                            }}
                            className="py-4 pl-10"
                        >
                            <li>
                                associare in modo corretto licenze, certificati
                                SSL e servizi DNS ai relativi intestatari, così
                                da garantire che ogni servizio sia assegnato a
                                un soggetto identificabile. È l'unico modo che
                                abbiamo per contrastare gli utilizzi impropri;
                            </li>
                            <li>
                                individuare con precisione l'intestatario del
                                servizio in caso di richieste da parte delle
                                autorità competenti. Un aspetto che tutela
                                l'intera supply chain e, in primo luogo, te come
                                Partner.
                            </li>
                        </ul>
                        I dati forniti non verranno mai utilizzati per attività
                        commerciali, promozionali o di contatto diretto nei
                        confronti dei tuoi clienti. Il rapporto con il cliente
                        finale è e resta tuo al 100%. <br /> <br /> I nostri
                        patti sono chiari, le nostre collaborazioni sono
                        durature. Questo è l'unico vero motivo per cui ti
                        chiediamo di inserire i dati del tuo cliente finale.
                    </div>

                    <div className="grid grid-cols-1 gap-5 md:grid-cols-4">
                        {sections.map((section, i) => (
                            <React.Fragment key={i}>
                                {section.fields.map((field) => {
                                    const input = (
                                        <InputField
                                            label={field.label}
                                            placeholder={field.placeholder}
                                            name={field.name}
                                            type={field.type}
                                            value={state.data[field.name] || ""}
                                            onChange={handleChange}
                                            required={field.required || false}
                                            tooltip={field.tooltip}
                                            state={getFieldState(field.name)}
                                            error={getFieldError(field.name)}
                                        />
                                    );

                                    return (
                                        <div
                                            key={field.name}
                                            className={field.colSpan ?? ""}
                                        >
                                            {input}
                                        </div>
                                    );
                                })}

                                <Divider className="col-span-full" />
                            </React.Fragment>
                        ))}

                        <TextField
                            label="Descrizione"
                            placeholder="Descrizione"
                            name="description"
                            rows="4"
                            value={state.data.description || ""}
                            onChange={handleChange}
                            tooltip="Scrivi note aggiuntive utili all’attivazione in questo box"
                            state={
                                message.hasOwnProperty("errors")
                                    ? message.errors.hasOwnProperty(
                                          "data.description"
                                      )
                                        ? "error"
                                        : null
                                    : null
                            }
                            error={
                                message.hasOwnProperty("errors")
                                    ? message.errors.hasOwnProperty(
                                          "data.description"
                                      )
                                        ? message.errors["data.description"]
                                        : null
                                    : null
                            }
                            extra="col-span-2 md:col-span-full"
                        />
                    </div>
                </div>
            }
        />
    );
};

export default Step1;
